import { render } from "./CommodityAlertManage.vue?vue&type=template&id=0010a0ce&scoped=true"
import script from "./CommodityAlertManage.vue?vue&type=script&lang=js"
export * from "./CommodityAlertManage.vue?vue&type=script&lang=js"

import "./CommodityAlertManage.vue?vue&type=style&index=0&id=0010a0ce&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0010a0ce"]])

export default __exports__